import {
  o
} from "./chunk.ONXLNBOP.js";
import {
  e,
  i2,
  n,
  t
} from "./chunk.5E26GMTR.js";
import {
  $,
  component_styles_default,
  r,
  s4
} from "./chunk.3PRAXUFA.js";
import {
  __decorateClass
} from "./chunk.7RPYXGIF.js";

// node_modules/@shoelace-style/shoelace/dist/chunks/chunk.4CV4I4O2.js
var radio_group_styles_default = r` ${component_styles_default} :host { display: block; } .radio-group { border: solid var(--sl-panel-border-width) var(--sl-panel-border-color); border-radius: var(--sl-border-radius-medium); padding: var(--sl-spacing-large); padding-top: var(--sl-spacing-x-small); } .radio-group .radio-group__label { font-family: var(--sl-input-font-family); font-size: var(--sl-input-font-size-medium); font-weight: var(--sl-input-font-weight); color: var(--sl-input-color); padding: 0 var(--sl-spacing-2x-small); } ::slotted(sl-radio:not(:last-of-type)) { display: block; margin-bottom: var(--sl-spacing-2x-small); } .radio-group:not(.radio-group--has-fieldset) { border: none; padding: 0; margin: 0; min-width: 0; } .radio-group:not(.radio-group--has-fieldset) .radio-group__label { position: absolute; width: 0; height: 0; clip: rect(0 0 0 0); clip-path: inset(50%); overflow: hidden; white-space: nowrap; } `;

// node_modules/@shoelace-style/shoelace/dist/chunks/chunk.PC2XE7K3.js
var RADIO_CHILDREN = ["sl-radio", "sl-radio-button"];
var SlRadioGroup = class extends s4 {
  constructor() {
    super(...arguments);
    this.hasButtonGroup = false;
    this.label = "";
    this.fieldset = false;
  }
  connectedCallback() {
    super.connectedCallback();
    this.setAttribute("role", "radiogroup");
  }
  getAllRadios() {
    return [...this.querySelectorAll(RADIO_CHILDREN.join(","))].filter((el) => RADIO_CHILDREN.includes(el.tagName.toLowerCase()));
  }
  handleRadioClick(event) {
    const target = event.target;
    const checkedRadio = target.closest(RADIO_CHILDREN.map((selector) => `${selector}:not([disabled])`).join(","));
    if (checkedRadio) {
      const radios = this.getAllRadios();
      radios.forEach((radio) => {
        radio.checked = radio === checkedRadio;
        radio.input.tabIndex = radio === checkedRadio ? 0 : -1;
      });
    }
  }
  handleKeyDown(event) {
    var _a;
    if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(event.key)) {
      const radios = this.getAllRadios().filter((radio) => !radio.disabled);
      const checkedRadio = (_a = radios.find((radio) => radio.checked)) != null ? _a : radios[0];
      const incr = ["ArrowUp", "ArrowLeft"].includes(event.key) ? -1 : 1;
      let index = radios.indexOf(checkedRadio) + incr;
      if (index < 0) {
        index = radios.length - 1;
      }
      if (index > radios.length - 1) {
        index = 0;
      }
      this.getAllRadios().forEach((radio) => {
        radio.checked = false;
        radio.input.tabIndex = -1;
      });
      radios[index].focus();
      radios[index].checked = true;
      radios[index].input.tabIndex = 0;
      event.preventDefault();
    }
  }
  handleSlotChange() {
    const radios = this.getAllRadios();
    const checkedRadio = radios.find((radio) => radio.checked);
    this.hasButtonGroup = !!radios.find((radio) => radio.tagName.toLowerCase() === "sl-radio-button");
    radios.forEach((radio) => {
      radio.setAttribute("role", "radio");
      radio.input.tabIndex = -1;
    });
    if (checkedRadio) {
      checkedRadio.input.tabIndex = 0;
    } else if (radios.length > 0) {
      radios[0].input.tabIndex = 0;
    }
  }
  render() {
    const defaultSlot = $`<slot @click=${this.handleRadioClick} @keydown=${this.handleKeyDown} @slotchange=${this.handleSlotChange}></slot>`;
    return $`<fieldset part="base" class=${o({
      "radio-group": true,
      "radio-group--has-fieldset": this.fieldset
    })} ><legend part="label" class="radio-group__label"><slot name="label">${this.label}</slot></legend>${this.hasButtonGroup ? $`<sl-button-group part="button-group">${defaultSlot}</sl-button-group>` : defaultSlot}</fieldset>`;
  }
};
SlRadioGroup.styles = radio_group_styles_default;
__decorateClass([
  i2("slot:not([name])")
], SlRadioGroup.prototype, "defaultSlot", 2);
__decorateClass([
  t()
], SlRadioGroup.prototype, "hasButtonGroup", 2);
__decorateClass([
  e()
], SlRadioGroup.prototype, "label", 2);
__decorateClass([
  e({ type: Boolean, attribute: "fieldset" })
], SlRadioGroup.prototype, "fieldset", 2);
SlRadioGroup = __decorateClass([
  n("sl-radio-group")
], SlRadioGroup);

export {
  radio_group_styles_default,
  SlRadioGroup
};
